import styled from 'styled-components'

export const StyledCardDiv = styled.div`
    width: 80%;
    margin-left: 10%;
    margin-top: 10%;
`;